import request from './api'


export async function getContracts(mode) {
    try {
        const res = await request('/api/budget-consumer/contracts', 'POST', {mode})
        const contracts = res?.contracts;
        return {
            isOk: true,
            data: contracts
        }
    } catch (e) {
        return {
            isOk: true,
            message: e.message,
        }
    }
}

export async function getModes() {
    try {
        const res = await request('/api/budget-consumer/modes', 'GET')
        const data = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : [])
        return {
            isOk: true,
            data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message,
        }
    }
}

export async function getPurchaseReasons() {
    try {
        const res = await request('/api/budget-consumer/purchase-reasons', 'GET')
        const data = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : [])
        return { isOk: true, data }
    } catch (e) {
        return {
            isOk: true,
            message: e.message,
        }
    }
}

export async function getFundSources() {
    try {
        const res = await request('/api/budget-consumer/fund-sources', 'GET')
        const data = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : [])
        return { isOk: true, data }
    } catch (e) {
        return {
            isOk: false,
            message: e.message,
        }
    }
}

export async function getTreasuries() {
    try {
        const res = await request('/api/budget-consumer/treasuries', 'GET')
        const data = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : [])
        return { isOk: true, data }
    } catch (e) {
        return {
            isOk: false,
            message: e.message,
        }
    }
}

export async function getRequestAttach(fd){
    try {
        const res = await request('/api/budget-consumer/add-contract/pdf', 'POST', fd)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function addContract(formData){
    try {
        const res = await request('/api/budget-consumer/add-contract', 'POST', formData, 'multipart')
        return {
            isOk: true,
            message: res.message,
            status: res.status,
            id: res.id,
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function changeContract(formData){
    try {
        const res = await request('/api/budget-consumer/change-contract/submit', 'POST', formData, 'multipart')
        return {
            isOk: true,
            data: res,
            message: res?.message,
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function delContract(formData){
    try {
        const res = await request('/api/budget-consumer/del-contract/submit', 'POST', formData, 'multipart')
        return {
            isOk: true,
            data: res,
            message: res?.message,
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}
